import { Component } from '@angular/core';
import { PasswordModule } from 'primeng/password';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { LayoutService } from '../../../layout/service/app.layout.service';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { ChipsModule } from 'primeng/chips';
import { AuthService } from '../../../../services/auth.service';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageService } from '../../../../i18n/language.service';

@Component({
  selector: 'bo-login',
  templateUrl: './login.component.html',
  imports: [
    PasswordModule,
    FormsModule,
    RouterLink,
    ReactiveFormsModule,
    ButtonModule,
    RippleModule,
    ChipsModule,
    TranslateModule,
  ],
  styles: [
    `
      :host ::ng-deep .pi-eye,
      :host ::ng-deep .pi-eye-slash {
        transform: scale(1.6);
        margin-right: 1rem;
        color: var(--primary-color) !important;
      }
    `,
  ],
})
export class LoginComponent {
  signInForm = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [Validators.required]),
  });

  constructor(
    public layoutService: LayoutService,
    public languageService: LanguageService,
    private readonly _authService: AuthService,
    private readonly _router: Router,
    private readonly _route: ActivatedRoute,
  ) {}

  async loginEmailPwd() {
    if (this.signInForm.valid) {
      const userToken = await this._authService.signInEmailPwd(
        this.signInForm.value.email || '',
        this.signInForm.value.password || '',
      );
      this.handleLoginToken(userToken);
    }
  }

  async signInGoogle() {
    const userToken = await this._authService.signInProviderDesktop('google');
    this.handleLoginToken(userToken);
  }

  private handleLoginToken(userToken: string | undefined) {
    if (!userToken) {
      alert('login_error');
    } else {
      const returnUrl = this._route.snapshot.queryParamMap.get('returnUrl')?.trim() ?? '';
      if (this.isSafeInternalReturnUrl(returnUrl)) {
        void this._router.navigateByUrl(returnUrl);
      } else {
        void this._router.navigate(['/']);
      }
    }
  }

  /** Only in-app relative paths; blocks open redirects and login loop. */
  private isSafeInternalReturnUrl(url: string): boolean {
    if (!url.startsWith('/') || url.startsWith('//')) {
      return false;
    }
    if (url === '/login' || url.startsWith('/login?')) {
      return false;
    }
    try {
      const tree = this._router.parseUrl(url);
      if (tree.fragment?.includes('//')) {
        return false;
      }
    } catch {
      return false;
    }
    return true;
  }
}
